import { makeAutoObservable } from 'mobx'

class LayoutStore {
  openKeys: string[] = []

  constructor() {
    makeAutoObservable(this)
  }

  setOpenKeys(keys: string[]) {
    this.openKeys = keys
  }
}

const layoutStore = new LayoutStore()
export const useLayoutStore = () => layoutStore
export default layoutStore
